
const FROSTLAB_BACKEND = "https://script.google.com/macros/s/AKfycbyTS10gJCNBxOBMW-tmbFP-7brg1uDITp8oMCroH7oLJ-yeHMhCK8FJi1ZMn9kTamrb/exec";
function val(id){ return (document.getElementById(id).value || '').trim(); }
function joinList(a){ return a.length > 1 ? a.slice(0,-1).join(', ') + ' and ' + a[a.length-1] : a[0]; }
function focusFirst(ids){ for(var i=0;i<ids.length;i++){ var el = document.getElementById(ids[i]); if(el && !el.value){ el.focus(); return; } } }
document.getElementById('infForm').addEventListener('submit', function(e){
  e.preventDefault();
  var m = document.getElementById('msg');
  /* four address fields -> one "street, city, ST zip" string the backend already understands,
     plus the individual parts in case they are wanted later. */
  var street = val('stAddr'), city = val('stCity'), state = val('stState'), zip = val('stZip');
  var lastLine = (state + ' ' + zip).trim();
  var shipTo = [street, city, lastLine].filter(function(p){ return !!p; }).join(', ');
  var data = { formType:'influencer', name:val('nm'), handle:val('hd'), platform:val('pf'),
    followers:val('fl'), email:val('em'), phone:val('ph'), audience:val('au'),
    shipTo:shipTo, street:street, city:city, state:state, zip:zip, why:val('wy') };
  if(!data.name || !data.handle || !data.followers || !data.email){
    m.className = 'fmsg err'; m.textContent = 'Please fill in your name, handle, followers and email.'; return;
  }
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(data.email)){
    m.className = 'fmsg err'; m.textContent = 'Enter a valid email address.'; return;
  }
  var addrMiss = [];
  if(!street) addrMiss.push('street address');
  if(!city) addrMiss.push('city');
  if(!state) addrMiss.push('state');
  if(!zip) addrMiss.push('ZIP code');
  if(addrMiss.length === 4){
    m.className = 'fmsg err'; m.textContent = 'Please add the address we should ship your package to.';
    document.getElementById('stAddr').focus(); return;
  }
  if(addrMiss.length){
    m.className = 'fmsg err';
    m.textContent = 'Please finish your shipping address \u2014 add your ' + joinList(addrMiss) + '.';
    focusFirst(['stAddr','stCity','stState','stZip']); return;
  }
  if(!/^[0-9]{5}$/.test(zip)){
    m.className = 'fmsg err'; m.textContent = 'Enter a 5-digit ZIP code.';
    document.getElementById('stZip').focus(); return;
  }
  m.className = 'fmsg ok'; m.textContent = 'Sending…';
  fetch(FROSTLAB_BACKEND, { method:'POST', mode:'no-cors',
    headers:{'Content-Type':'text/plain;charset=utf-8'}, body: JSON.stringify(data) })
    .catch(function(){})
    .then(function(){
      document.getElementById('formCard').style.display = 'none';
      document.getElementById('doneCard').classList.add('on');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});

/* ZIP stays numeric and 5 digits, however it is typed or pasted */
document.getElementById('stZip').addEventListener('input', function(){
  var v = this.value.replace(/[^0-9]/g,'').slice(0,5);
  if(v !== this.value) this.value = v;
});

/* ---- universal double-submit guard (a real distributor lead came in twice) ---- */
(function(){
  document.addEventListener('submit', function(e){
    var f = e.target; if(!f || f.tagName !== 'FORM') return;
    var btn = f.querySelector('button[type="submit"], .submit, button:not([type="button"])');
    if(f.dataset.flBusy === '1'){ e.preventDefault(); e.stopImmediatePropagation(); return; }
    f.dataset.flBusy = '1';
    if(btn){ btn.disabled = true; var t = btn.textContent; btn.dataset.flTxt = t; btn.textContent = 'Sending\u2026'; }
    setTimeout(function(){
      f.dataset.flBusy = '';
      if(btn){ btn.disabled = false; if(btn.dataset.flTxt) btn.textContent = btn.dataset.flTxt; }
    }, 6000);
  }, true);
  /* same guard for button-driven (non-form) senders */
  ['join','submit'].forEach(function(id){
    var b = document.getElementById(id); if(!b || b.form) return;
    b.addEventListener('click', function(){
      if(b.dataset.flBusy === '1') return;
      b.dataset.flBusy = '1'; b.disabled = true;
      setTimeout(function(){ b.dataset.flBusy=''; b.disabled=false; }, 6000);
    });
  });
})();
